import React, { useRef, useState } from "react"

import { Row, Col } from "reactstrap"

import allowCamera from "../../../assets/images/gif/allow-camera.gif"
import location from "../../../assets/images/gif/location.gif"
import selfie from "../../../assets/images/gif/selfie.gif"
import { useDispatch, useSelector } from "react-redux"
import {
  useGenerateTemplateTokenMutation,
  useLazyGetStatusOfOldDigioRequestQuery,
  useUpdateDiogioRequestStatusMutation,
} from "store/api/kyc/kyc"
import Spinners from "components/Common/Spinner"
import { useEffect } from "react"
import FullPageLoader from "components/fullPageLoader"
import toast from "react-hot-toast"
import logo from "../../../assets/images/logo-light1.svg"

const CaptureSelfie = ({ kycData, profileData }) => {
  const { user, userType } = useSelector((state) => state.user)
  const [isLoading, setIsLoading] = useState(false)
  const [loader, setLoader] = useState(false)
  const [requestData, setRequestData] = useState(null)
  const dispatch = useDispatch()
  const [getToken, { isFetching }] = useGenerateTemplateTokenMutation()
  const [getRequestStatus] = useLazyGetStatusOfOldDigioRequestQuery()
  const [updateDiogioRequestTrigger] = useUpdateDiogioRequestStatusMutation()
  const intervalRef = useRef(null)
  const template_name = "SELFIE_WITOUT_OTP"

  const startCaptureSelfie = async () => {
    try {
      setIsLoading(true)
      const { data, success, message } = await getToken({
        template_name,
      }).unwrap()

      if (success) {
        if (window.Digio) {
          const options = {
            environment: "production", //<sandbox, production>
            callback: function (response) {
              if (response.hasOwnProperty("error_code")) {
                console.log("Error occurred in process", response)
              } else {
                updateDiogioRequestTrigger({
                  id: response.digio_doc_id,
                }).unwrap()
                setLoader(true)
                setTimeout(() => {
                  setLoader(false)
                  window.location.reload()
                }, 10000)
              }
            },
            event_listener: function (event) {
              console.log("event_listener", event)
            },
            is_iframe: true,
            logo: logo,
            theme: {
              primaryColor: "#000000",
              secondaryColor: "#000000",
            },
          }

          const digio = new window.Digio(options)
          digio.init()

          const documentId = data.documentId
          const identifier = data.identifier
          const tokenId = data.tokenId

          digio.submit(documentId, identifier, tokenId)
          // If using token approach:
        } else {
          console.error("Digio SDK not loaded")
        }
      } else {
        toast.error(message, { id: "toastMessage" })
      }
    } catch (error) {
      toast.error("Something went wrong, Please try again after sometime", {
        id: "toastMessage",
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    onGetRequestStatus()

    return () => {
      if (intervalRef) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  const onGetRequestStatus = async () => {
    try {
      const { data } = await getRequestStatus({ template_name }).unwrap()
      setRequestData(data)
      if (data.status === "kyc.request.approved" && intervalRef?.current) {
        window.location.reload()
        clearInterval(intervalRef.current)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (kycData && requestData) {
      if (
        profileData.status === "PENDING" &&
        requestData.status === "kyc.request.completed" &&
        requestData.kyc_status === "KYC_PENDING"
      ) {
        setLoader(true)
        const id = setInterval(() => {
          onGetRequestStatus()
        }, 10000)
        intervalRef.current = id
      }
    }
  }, [requestData, kycData])

  if (loader)
    return (
      <FullPageLoader loadingText="Please wait we are verifying your captured selfie..." />
    )

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Capture Selfie</h5>
        <Row className="mb-2">
          <div className="capture-selfie-section">
            <div className="capture-selfie-inner-box">
              <div className="selfie-image">
                <img src={selfie} alt="" />
              </div>
              <p>
                Ensure your face is exposed to sufficient lighting to capture a
                clear picture.
              </p>
            </div>
            <div className="capture-selfie-inner-box">
              <div className="selfie-image">
                <img src={location} alt="" />
              </div>
              <p>Please make sure your device's location is turned on.</p>
            </div>
            <div className="capture-selfie-inner-box">
              <div className="selfie-image">
                <img src={allowCamera} alt="" />
              </div>
              <p>
                Please make sure you allow Prachay to access your device's
                location and camera when prompted.
              </p>
            </div>
            <div className="capture-selfie-text">
              In case the page doesn't load after giving permissions, try
              refreshing.
            </div>

            <Col sm={12}>
              <div className="d-flex align-items-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={() => startCaptureSelfie()}
                >
                  {isLoading || isFetching ? <Spinners /> : "Capture Selfie"}
                </button>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  )
}

export default CaptureSelfie
